/**
 * Algolia indices
 * Must stay synced with the backend:
 * @see src/modules/algolia/enums/AlgoliaIndex.php
 */
export enum AlgoliaIndices {
  MOST_POPULAR = 'popular_desc',
  POSTDATE_DESC = 'postDate_desc',
  PRICE_ASC = 'price_asc',
  PRICE_DESC = 'price_desc',
  PRIMARY = 'primary',
  TITLE_ASC = 'title_asc',
  TITLE_DESC = 'title_desc',
  UPDATED_DESC = 'updated_desc',
}
